import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RemoveShoppingCartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"remove_shopping_cart"}/>
}
